import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store';
import i18n from "./language/index"
import vant from 'vant';
import utils from "@/utils/index";
import 'vant/lib/index.css';

require('./assets/css/reset.css');
require('./assets/css/common.scss');

let webApp = createApp(App);
function digitalNumber(num) {
    if (num && !isNaN(num)) {
        return utils.keepTwoDecimalFull(num);
    } else {
        return '0.00'
    }
}

// import eruda from 'eruda'
// eruda.init()

// 千位符号
function numFormat(num){
    if (num) {
        num = num.toString().split(".");  // 分隔小数点
        var arr=num[0].split("").reverse();  // 转换成字符数组并且倒序排列
        var res=[];
        for(var i=0,len=arr.length;i<len;i++){
            if(i%3===0&&i!==0){
                res.push(",");   // 添加分隔符
            }
            res.push(arr[i]);
        }
        res.reverse(); // 再次倒序成为正确的顺序
        if(num[1]){  // 如果有小数的话添加小数部分
            res=res.join("").concat("."+num[1]);
        }else{
            res=res.join("");
        }
        return res;
    } else {
        return 0;
    }
}

webApp.directive('real-img', {
    // 在元素被插入到 DOM 前调用，通常进行css的操作
    async beforeMount(el, binding, vnode) {
        let defaultURL = require('@/assets/img/errorImg/3.png');//错误默认显示图片

        if (el.width && el.height && el.width < el.height) {
            defaultURL = require('@/assets/img/errorImg/1.png');
        }

        if (vnode.props && vnode.props.errorimg) {
            defaultURL = vnode.props.errorimg;
        }
    
        let imgURL = binding.value;//获取图片地址
        if (imgURL) {
            let exist = await imageIsExist(imgURL);
            if (exist) {
                el.setAttribute('src', imgURL);
            } else {
                el.setAttribute('src', defaultURL);
            }
        } else {
            el.setAttribute('src', defaultURL);
        }
    },
    async beforeUpdate(el, binding, vnode) {
        if (vnode && vnode.props && vnode.props.errorimg) {
            // 比例待优化重新计算
            let defaultURL = require('@/assets/img/errorImg/3.png');//错误默认显示图片

            if (el.width && el.height && el.width < el.height) {
                defaultURL = require('@/assets/img/errorImg/1.png');//错误默认显示图片
            }

            if (vnode.props && vnode.props.errorimg) {
                defaultURL = vnode.props.errorimg;
            }
        
            let imgURL = binding.value;//获取图片地址
            if (imgURL) {
                let exist = await imageIsExist(imgURL);
                if (exist) {
                    el.setAttribute('src', imgURL);
                } else {
                    el.setAttribute('src', defaultURL);
                }
            } else {
                el.setAttribute('src', defaultURL);
            }
        }
        
    }
});

/**
* 检测图片是否存在
* @param url
*/
let imageIsExist = function(url) {
    return new Promise((resolve) => {
        var img = new Image();
        img.onload = function () {
            if (this.complete == true){
                resolve(true);
                img = null;
            }
        }
        img.onerror = function () {
            resolve(false);
            img = null;
        }
        img.src = url;
    })
}
webApp.config.globalProperties.numFormat = numFormat;
webApp.config.globalProperties.digitalNumber = digitalNumber;
webApp.use(store).use(router).use(i18n).use(vant).mount('#app');


